function getCookie(name) {
    const value = '; ' + document.cookie
    const parts = value.split('; ' + name + '=')
    if (parts.length == 2) {
        return parts
            .pop()
            .split(';')
            .shift()
    }
    return null
}

function removeCookie(name) {
    document.cookie = name + '=; Max-Age=-99999999;'
}

function setCookie(name, value, days) {
    let expires = ''
    if (days) {
        const date = new Date()
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
        expires = '; expires=' + date.toUTCString()
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/'
}

class Auth {
    /**
     * Authenticate a user. Save a token string in Local Storage
     *
     * @param {string} token
     */
    static authenticateUser(token) {
        // localStorage.setItem('token', token);
        setCookie('token', token, 365)
        setCookie('version', 'v2', 365)
    }

    /**
     * Check if a user is authenticated - check if a token is saved in Local Storage
     *
     * @returns {boolean}
     */
    static isUserAuthenticated() {
        if (getCookie('token') !== null) {
            if (getCookie('version') === 'v2') {
                return true
            } else {
                // v1 사용자의 경우 로그아웃 시키기
                removeCookie('token')
                alert('앱 업데이트로 인해 자동 로그아웃 됩니다.')
                return false
            }
        } else {
            return false
        }
        // return (getCookie('token') !== null && getCookie('version') === 'v2')
    }

    static selectedProject() {
        return getCookie('project') !== null
    }

    /**
     * Deauthenticate a user. Remove a token from Local Storage.
     *
     */
    static deauthenticateUser() {
        // localStorage.removeItem('token');
        removeCookie('token')
        removeCookie('version')
    }

    /**
     * Get a token value.
     *
     * @returns {string}
     */

    static getToken() {
        // return localStorage.getItem('token');
        return getCookie('token')
    }
}

export default Auth



// WEBPACK FOOTER //
// ./Src/Modules/Auth.js